import React from "react";
import { UserProvider } from "./UserProvider";
import { StatsProvider } from "./StatsProvider";
import { CompanyProvider } from "./CompanyProvider";
import { FilterCompaniesStateProvider } from "./FilterCompaniesProvider";
import { FilterJobsProvider } from "./FilterJobsProvider";
import { JobPostProvider } from "./JobPostProvider";
import { ThemeProvider } from "@mui/material/styles";
import theme from "@/designSystem/theme";
import { GoogleOAuthProvider } from "@react-oauth/google";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <GoogleOAuthProvider clientId="YOUR_GOOGLE_CLIENT_ID">
        <UserProvider>
          <StatsProvider>
            <CompanyProvider>
              <JobPostProvider>
                <FilterCompaniesStateProvider>
                  <FilterJobsProvider>{children}</FilterJobsProvider>
                </FilterCompaniesStateProvider>
              </JobPostProvider>
            </CompanyProvider>
          </StatsProvider>
        </UserProvider>
      </GoogleOAuthProvider>
    </ThemeProvider>
  );
}
